import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "content-tab" }

import { ref, computed } from "vue";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";
import Recommend from "@/components/modules/article/Recommend.vue";
import Favorite from "@/components/modules/article/Favorite.vue";
import Follow from "@/components/modules/article/Follow.vue";

// Tab
const activeMenu = "article";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const tabStatus = {
  recommendTab: "generalpurpose06-01",
  favoriteTab: "generalpurpose06-02",
  followTab: "generalpurpose06-03",
};

// componentId
const componentId = ref(tabStatus.recommendTab);

// Component with tab
const currentTabComponent = computed(() => {
  switch (componentId.value) {
    case tabStatus.recommendTab:
      return Recommend;
    case tabStatus.favoriteTab:
      return Favorite;
    case tabStatus.followTab:
      return Follow;
    default:
      return Recommend;
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: componentId.value }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header, { "active-menu": activeMenu }),
      _createElementVNode("main", null, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", {
            class: _normalizeClass(["content-tab-item", { active: componentId.value === tabStatus.recommendTab }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (componentId.value = tabStatus.recommendTab))
          }, _toDisplayString(_ctx.$t("article_tab_recommend")), 3),
          _createElementVNode("li", {
            class: _normalizeClass(["content-tab-item", { active: componentId.value === tabStatus.favoriteTab }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (componentId.value = tabStatus.favoriteTab))
          }, _toDisplayString(_ctx.$t("article_tab_favorite")), 3),
          _createElementVNode("li", {
            class: _normalizeClass(["content-tab-item", { active: componentId.value === tabStatus.followTab }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (componentId.value = tabStatus.followTab))
          }, _toDisplayString(_ctx.$t("article_tab_follow")), 3)
        ]),
        (_openBlock(), _createBlock(_resolveDynamicComponent(currentTabComponent.value)))
      ]),
      _createVNode(Footer, {
        "scroll-target": componentId.value,
        "active-menu": activeMenu
      }, null, 8, ["scroll-target"])
    ])
  ], 8, _hoisted_1))
}
}

})